import React, {useEffect, useState} from 'react';
import Select from "./common/Select";
import Bitrix24 from "../server/bitrix24";
import moment from "moment";
import Helper from "../common/helper";
import Server from "../server/server";
import CardOrder from "./CardOrder";
import CardProduct from "./CardProduct";
import AddProduct from "./AddProduct";
import {Modal, Toast, ToastContainer} from "react-bootstrap";

const Card = ({dealId}) => {

    const bitrixConnect = new Bitrix24()
    const server = new Server()

    const [price, setPrice] = useState(null);
    const [store, setStore] = useState(null);

    const [modal, setModal] = useState(false);
    const [loadPriceStore, setLoadPriceStore] = useState(false);

    const [deal, setDeal] = useState({});
    const [dealProduct, setDealProduct] = useState([]);
    const [products1C, setProducts1C] = useState([]);
    const [company, setCompany] = useState({});
    const [optionsPodrazdelenie, setOptionsPodrazdelenie] = useState([
        {value: '', name: 'Не выбран'},
    ]);
    const [optionsPrice, setOptionsPrice] = useState([
        {value: '', name: 'Не выбран'},
    ]);
    const [optionsDogovor, setOptionsDogovor] = useState([
        {value: '', name: 'Не выбран'},
    ]);
    const [optionsAddress, setOptionsAddress] = useState([
        {value: '', name: 'Не выбран'},
    ]);

    useEffect(() => {
        console.log(dealProduct)
    }, [dealProduct])

    useEffect(() => {
        server.loadProps().then((result) => {
            setOptionsPrice([{value: '', name: 'Не выбран'}].concat(result.PRICES.PRICE.map((item) => {
                return {
                    value: item.XML_ID,
                    name: item.NAME
                }
            })))
        })
    }, [])

    useEffect(() => {
        bitrixConnect.loadDeal(dealId).then((result) => {
            setDeal({
                ...result,
                UF_CRM_DEAL_DATE: moment(result.UF_CRM_DEAL_DATE).format('YYYY-MM-DD'),
                UF_CRM_DEAL_NEVIPOLNEN: result.UF_CRM_DEAL_NEVIPOLNEN === "1",
                UF_CRM_DEAL_TRANZIT: result.UF_CRM_DEAL_TRANZIT === "1",
                UF_CRM_DEAL_UPACLIST: result.UF_CRM_DEAL_UPACLIST === "1",
                DEAL_PAY: result[Helper.fields.DEAL_PAY] ?? 'Касса',
                DEAL_PAY_TAX_INCLUDE: result[Helper.fields.DEAL_PAY_TAX_INCLUDE] === "1",
                UF_CRM_DEAL_DATEDELIVERY: moment(result.UF_CRM_DEAL_DATEDELIVERY).format('YYYY-MM-DD'),
                UF_CRM_DEAL_HOOTDELIVERY: result.UF_CRM_DEAL_HOOTDELIVERY === "1",
                UF_CRM_DEAL_DOSTAVKA: result.UF_CRM_DEAL_DOSTAVKA ?? 'Самовывоз',
            })
        })
        bitrixConnect.loadDealProduct(dealId).then((result) => {
            setDealProduct(result)
        })
    }, [dealId])

    useEffect(() => {
        setPrice(deal.UF_CRM_DEAL_PRICE ?? null)
        setStore(deal.UF_CRM_DEAL_PODRAZDELENIE ?? null)
    }, [deal])

    useEffect(() => {
        if (deal.COMPANY_ID) {
            bitrixConnect.loadCompany(deal.COMPANY_ID).then((result) => {
                setCompany(result)
                setDeal(prevState => ({
                    ...prevState,
                    UF_CRM_DEAL_ADDRESS: result[Helper.fields.COMPANY_ADDRESS][0] ?? '',
                    COMPANY: result.TITLE
                }))
            })

            bitrixConnect.loadDogovor(deal.COMPANY_ID).then((result) => {
                setOptionsDogovor([{value: '', name: 'Не выбран'}].concat(result.map(item => {
                    return {
                        value: item.ID,
                        name: item.NAME
                    }
                })))
            })

            bitrixConnect.loadAddress(deal.COMPANY_ID).then((result) => {
                setOptionsAddress([{value: '', name: 'Не выбран'}].concat(result.map(item => {
                    return {
                        value: item.ID,
                        name: item.NAME
                    }
                })))
            })
        }
    }, [deal.COMPANY_ID])

    useEffect(() => {
        if (deal.DEAL_PAY !== 'сНДС') {
            setDeal(prevState => ({
                ...prevState,
                DEAL_PAY_TAX_INCLUDE: false
            }))
        } else {
            setDeal(prevState => ({
                ...prevState,
                DEAL_PAY_TAX_INCLUDE: true
            }))
        }
    }, [deal.DEAL_PAY])

    useEffect(() => {
        setDealProduct(dealProduct.map(item => {
            const product = products1C.find(product => product.XML_ID === item.XML_ID)

            const price = parseInt(product?.PRICE ?? item.PRICE)

            return {
                ...item,
                NEW_PRICE: price + (price * deal.UF_CRM_DEAL_NACENKA / 100),
            }
        }))
    }, [deal.UF_CRM_DEAL_NACENKA])

    useEffect(() => {
        if (company[Helper.fields.COMPANY_XML]) {
            server.loadCompany(company[Helper.fields.COMPANY_XML]).then((result) => {
                setDeal(prevState => ({
                    ...prevState,
                    lmitShipment: result.LmitShipment,
                    [Helper.fields.DEAL_OTSROCHKA]: result.DayPayment,
                    debt: result.Debt,
                    overdueDebt: result.OverdueDebt,
                }))
                setOptionsPodrazdelenie([{value: '', name: 'Не выбран'}].concat(result.STORES.STORE.map(item => {
                    return {
                        value: item.XML_ID,
                        name: item.NAME
                    }
                })))
            })
        }
    }, [company])

    useEffect(() => {
        if (price && store) {
            setLoadPriceStore(true)
            server.loadProducts(store, price).then((result) => {
                setProducts1C(result.PRODUCTS.PRODUCT ?? [])
                setLoadPriceStore(false)
            })
        }
    }, [price, store])

    const saveDeal = () => {

        if (['C2:UC_2HH97M', 'C2:UC_3OLCPE', 'C2:UC_VWFK8M'].includes(deal.STAGE_ID)) {
            alert('Изменение заказа не возможно')
            return false;
        }

        const fields = {
            'CATEGORY_ID': 2,
            'UF_CRM_DEAL_NUMBER': deal.UF_CRM_DEAL_NUMBER,
            'UF_CRM_DEAL_PODRAZDELENIE': deal.UF_CRM_DEAL_PODRAZDELENIE,
            'UF_CRM_DEAL_ADDRESS': deal.UF_CRM_DEAL_ADDRESS,
            'UF_CRM_DEAL_DATE': deal.UF_CRM_DEAL_DATE,
            'UF_CRM_DEAL_NEVIPOLNEN': deal.UF_CRM_DEAL_NEVIPOLNEN ? 1 : 0,
            'UF_CRM_DEAL_TRANZIT': deal.UF_CRM_DEAL_TRANZIT ? 1 : 0,
            'UF_CRM_DEAL_UPACLIST': deal.UF_CRM_DEAL_UPACLIST ? 1 : 0,
            'UF_CRM_DEAL_PRICE': deal.UF_CRM_DEAL_PRICE,
// 'UF_CRM_DEAL_STORE': $('[name="UF_CRM_DEAL_STORE"]').val(),
            [Helper.fields.DEAL_DOGOVOR]: deal[Helper.fields.DEAL_DOGOVOR],
            'UF_CRM_DEAL_DOSTAVKA': deal.UF_CRM_DEAL_DOSTAVKA,
            [Helper.fields.DEAL_PAY]: deal.DEAL_PAY,
            [Helper.fields.DEAL_PAY_TAX_INCLUDE]: deal.DEAL_PAY_TAX_INCLUDE ? 1 : 0,
            'UF_CRM_DEAL_SROKREZERVA': deal.UF_CRM_DEAL_SROKREZERVA,
            'UF_CRM_DEAL_NACENKA': deal.UF_CRM_DEAL_NACENKA,
            'UF_CRM_DEAL_DATEDELIVERY': deal.UF_CRM_DEAL_DATEDELIVERY,
            'UF_CRM_DEAL_HOOTDELIVERY': deal.UF_CRM_DEAL_HOOTDELIVERY ? 1 : 0,
            'UF_CRM_DEAL_STATUS': deal.UF_CRM_DEAL_STATUS,
            [Helper.fields.DEAL_OTSROCHKA]: deal[Helper.fields.DEAL_OTSROCHKA],
            [Helper.fields.DEAL_ADDRESS]: deal[Helper.fields.DEAL_ADDRESS],
            'OPENED': 'Y',
            'COMPANY_ID': deal.COMPANY_ID
        }

        if (dealId) {
            bitrixConnect.updateDeal(dealId, fields).then(result => {
                saveDealProduct(dealId)
            })
        } else {
            bitrixConnect.addDeal(fields).then(result => {
                saveDealProduct(result, true)
            })
        }
    }

    const saveDealProduct = (dealId, isNew = false) => {
        const rows = dealProduct.map(item => {
            return {
                PRODUCT_ID: item.PRODUCT_ID,
                PRODUCT_NAME: item.NAME,
                QUANTITY: item.COUNT,
                PRICE: item.NEW_PRICE ?? item.PRICE,
                TAX_RATE: 20,
                TAX_INCLUDE: deal.DEAL_PAY_TAX_INCLUDE ? 'Y' : 'N',
            }
        })

        bitrixConnect.saveDealProduct(dealId, rows).then(result => {
            if (isNew) {
                BX24.openPath('/crm/deal/details/' + dealId + '/')
            } else {
                BX24.reloadWindow()
            }
        })
    }

    return (
        <>
            <CardOrder setDeal={setDeal} deal={deal} company={company} optionsPodrazdelenie={optionsPodrazdelenie} optionsPrice={optionsPrice} optionsDogovor={optionsDogovor} optionsAddress={optionsAddress}/>
            <div className="row m-3">
                <div className="col">
                    <button type="button" className="btn btn-primary" onClick={() => setModal(true)}>Добавить
                    </button>
                </div>
            </div>
            <CardProduct dealProduct={dealProduct} setDealProduct={setDealProduct} products1C={products1C} className={"m-3"}/>
            <div className="row m-3">
                <div className="col">
                    <button id="save_deal" type="submit" className="btn btn-primary" onClick={() => saveDeal()}>Сохранить</button>
                </div>
            </div>
            <Modal show={modal} onHide={() => setModal(false)} dialogClassName="modal-90w">
                <Modal.Header closeButton>
                    <Modal.Title>Добавить номенклатуру</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <AddProduct dealProduct={dealProduct} setDealProduct={setDealProduct} products1C={products1C} setDeal={setDeal} deal={deal} optionsPodrazdelenie={optionsPodrazdelenie} optionsPrice={optionsPrice}/>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setModal(false)}>Закрыть</button>
                </Modal.Footer>
            </Modal>
            <ToastContainer position="top-end">
                {loadPriceStore && (
                    <Toast>
                        <Toast.Body>Загрузка цен и остатков</Toast.Body>
                    </Toast>
                )}
            </ToastContainer>
        </>
    )
}

export default Card